import { render, staticRenderFns } from "./PlusMinusField.vue?vue&type=template&id=5ba13fc0&scoped=true&"
import script from "./PlusMinusField.vue?vue&type=script&lang=js&"
export * from "./PlusMinusField.vue?vue&type=script&lang=js&"
import style0 from "./PlusMinusField.vue?vue&type=style&index=0&id=5ba13fc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../hoachipshop-ctv/client-ctv/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba13fc0",
  null
  
)

export default component.exports